import { resolveAppLanguage } from '../../../i18n/language';

/**
 * Full name for the current UI language: Arabic when locale is `ar`, English (`first_name`/`last_name`) for `en` and `zh`.
 * Falls back across scripts, then `username`.
 */
export function getLocalizedUserFullName(user, i18nLanguage) {
  if (!user) return '';
  const lang = resolveAppLanguage(i18nLanguage);
  const en = `${user.first_name || ''} ${user.last_name || ''}`.trim();
  const ar = `${user.first_name_ar || ''} ${user.last_name_ar || ''}`.trim();
  if (lang === 'ar') {
    return (ar || en || String(user.username || '').trim()).trim();
  }
  return (en || ar || String(user.username || '').trim()).trim();
}

/** Avatar initials matching the name shown for the current locale. */
export function getLocalizedUserInitials(user, i18nLanguage) {
  if (!user) return 'U';
  const lang = resolveAppLanguage(i18nLanguage);
  const fn =
    lang === 'ar'
      ? user.first_name_ar || user.first_name || ''
      : user.first_name || user.first_name_ar || '';
  const ln =
    lang === 'ar'
      ? user.last_name_ar || user.last_name || ''
      : user.last_name || user.last_name_ar || '';
  if (fn && ln) {
    return `${fn[0]}${ln[0]}`.toUpperCase();
  }
  if (fn) return fn[0].toUpperCase();
  if (user.username) return user.username[0].toUpperCase();
  return 'U';
}
